import { type FC } from 'react'
import classNames from 'classnames'

import styles from './FeedbackBox.module.scss'
import { Button } from '../../../components/Button/Button'

interface FeedbackBoxProps {
  title: string
  subtitle: string
  to: string
  onDismiss: VoidFunction
  onFeedbackClick: VoidFunction
  className?: string
}

export const FeedbackBox: FC<FeedbackBoxProps> = ({ title, subtitle, to, onDismiss, onFeedbackClick, className }) => {
  return (
    <div className={classNames(styles.feedback, className)}>
      <div className={styles.content}>
        <div className={styles.info}>
          <i className='bi bi-lightbulb' />
          <div className={styles.text}>
            <p className={styles.title}>{title}</p>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
        </div>
        <div className={styles.actions}>
          <a className={styles.link} href={to} target='_blank' rel='noopener noreferrer' onClick={onFeedbackClick}>
            Leave feedback
          </a>
          <Button variant='borderless' className={styles.closeButton} onClick={onDismiss} aria-label='Dismiss feedback'>
            <i className='bi bi-x-lg' />
          </Button>
        </div>
      </div>
    </div>
  )
}
